export default "__VITE_ASSET__d83ed000__"